export default {
  APPLICATION_ENGINEER: 'e1b6b7b4-a9f5-46e3-a736-9b9b2c11c78e',
  OPERATOR: 'aae5d0ce-ee43-4720-b261-106604fb3642',
  SUPER_ADMIN: '50a900b7-64ef-48f8-aa11-71e6e8b228c3',
  ADMIN: '8d7c2961-e9aa-4db2-a5e3-e211f1f71b46'
};
